import { render, staticRenderFns } from "./Complain.vue?vue&type=template&id=3bc1e5df&scoped=true"
import script from "./Complain.vue?vue&type=script&lang=js"
export * from "./Complain.vue?vue&type=script&lang=js"
import style0 from "./Complain.vue?vue&type=style&index=0&id=3bc1e5df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc1e5df",
  null
  
)

export default component.exports